import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';
import * as cfg from './app.config';
import { CfgVisumComponent } from './components/config/cfg-visum.component';
import { mekCVisumConfig } from './components/config/config-mek-c-visum';
import { mekDVisumConfig } from './components/config/config-mek-d-visum';
import { videxCVisumConfig } from './components/config/config-videx-c-visum';
import { videxDVisumConfig } from './components/config/config-videx-d-visum';
import { ImpressumComponent } from './components/impressum/impressum.component';

export const langfristigerAufenthaltPath = "langfristiger-aufenthalt";
export const kurzfristigerAufenthaltPath = "kurzfristiger-aufenthalt";

const routesForMEK: Routes = [
  { path: 'mek-' + langfristigerAufenthaltPath, component: CfgVisumComponent, providers: [{ provide: cfg.APP_CONFIG, useValue: mekDVisumConfig }] },
  { path: 'mek-' + kurzfristigerAufenthaltPath, component: CfgVisumComponent, providers: [{ provide: cfg.APP_CONFIG, useValue: mekCVisumConfig }] }
];

const routesForVIDEX: Routes = [
  {
    path: 'videx-' + langfristigerAufenthaltPath, component: CfgVisumComponent, providers: [{ provide: cfg.APP_CONFIG, useValue: videxDVisumConfig }]
  },
  {
    path: 'videx-' + kurzfristigerAufenthaltPath, component: CfgVisumComponent, providers: [{ provide: cfg.APP_CONFIG, useValue: videxCVisumConfig }]
  },
  {
    path: 'impressum',
    component: ImpressumComponent
  }
];

const defaultRoute: Route = { path: '', redirectTo: 'videx-' + langfristigerAufenthaltPath, pathMatch: 'full' };

const routes: Routes = [...routesForVIDEX, ...routesForMEK, defaultRoute];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
